import { render, staticRenderFns } from "./CreditInvoiceTemplate.vue?vue&type=template&id=54159fef&scoped=true"
import script from "./CreditInvoiceTemplate.vue?vue&type=script&lang=js"
export * from "./CreditInvoiceTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreditInvoiceTemplate.vue?vue&type=style&index=0&id=54159fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54159fef",
  null
  
)

export default component.exports